export const useFilterVisibility = (isShow: boolean = false) => {
  const { t } = useI18n();
  const route = useRoute();
  const isShowFilters = ref(isShow);

  const filtersToggleText: Ref<string> = computed(() =>
    isShowFilters.value ? t('hideCategories') : t('showCategories'),
  );

  const toggleFilters = (): void => {
    isShowFilters.value = !isShowFilters.value;
  };

  watch(
    () => route.fullPath,
    () => {
      if (!isShow) {
        isShowFilters.value = false;
      }
    },
  );

  return {
    isShowFilters,
    filtersToggleText,
    toggleFilters,
  };
};
